import { gql } from '@apollo/client';

export const CHECK_EMAIL = gql`
  query checkEmailExists ($email: String!, $checkInAuth0: Boolean) {
    checkEmailExists(email: $email, checkInAuth0: $checkInAuth0)
  }
`;
